<template>
  <div class="inicio">
    <portada />
    <soluciones />
    <!-- ----------------------Mejora tu empresa---------------------- -->
    <div class="py-4 py-lg-5 bg-light padding6 borde-sombreado">
      <div class="my-4">
        <titulo-seccion>
          ¡Mejora tu empresa
          <b>ya!</b>
        </titulo-seccion>
        <p
          class="py-2"
          style="font-size: 1.4em; color: #595959"
        >No esperes más para implementar los mejores software del mercado</p>
        <boton-enlace to="/contacto" size="lg">Contáctanos</boton-enlace>
      </div>
    </div>
    <!-- ------------------------------------------------------------------ -->
    <servicios class="borde-sombreado" />
    <!-- ----------------------Administra tu empresa---------------------- -->
    <div class="py-4 py-lg-5 borde-sombreado padding6">
      <div class="my-4">
        <titulo-seccion>
          ¡Administra tu empresa con tan solo
          <b>un software!</b>
        </titulo-seccion>
        <p
          class="py-2"
          style="font-size: 1.4em; color: #595959"
        >Adquiere el mejor sistema para gestionar todos los procesos de tu negocio</p>
        <boton-enlace to="/domit" size="lg">Comienza Ahora</boton-enlace>
      </div>
    </div>
    <!-- ------------------------------------------------------------------ -->
    <sectores-comerciales />
    <certificados />
    <Clientes class="borde-sombreado bg-light" />
  </div>
</template>
<script>
import Portada from "@/components/cliente/paginas/inicio/Portada.vue";
import Soluciones from "@/components/cliente/paginas/inicio/Soluciones.vue";
import Servicios from "@/components/cliente/paginas/inicio/Servicios.vue";
import Certificados from "@/components/cliente/paginas/inicio/Certificados.vue";
import SectoresComerciales from "@/components/cliente/paginas/inicio/SectoresComerciales.vue";
import Clientes from "@/components/cliente/paginas/inicio/Clientes.vue";
export default {
  name: "inicio",
  components: {
    Portada,
    Soluciones,
    Servicios,
    SectoresComerciales,
    Certificados,
    Clientes
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>
<style scoped>
.padding6 {
  padding: 0% 6%;
}
.borde-sombreado {
  -webkit-box-shadow: 0px 0px 8px 0px rgba(250, 250, 250, 1);
  -moz-box-shadow: 0px 0px 8px 0px rgba(250, 250, 250, 1);
  box-shadow: 0px 0px 8px 0px rgba(250, 250, 250, 1);
}
</style>